import ons from "onsenui";
import React from "react";
import { isDefined } from "../components/Generic/IsDefined";

const IDLE_FOR_A_WHILE_MILLISECONDS = 0;

export default function useWindowFocus() {
  const [isFocused, setFocused] = React.useState(true);
  const [isIOSIdleForAWhile, setIOSIdleForAWhile] = React.useState(false);

  React.useEffect(() => {
    let idleTimeout: NodeJS.Timeout;

    const onFocusListener = () => {
      setFocused(true);
      setIOSIdleForAWhile(false);

      if (isDefined(idleTimeout)) {
        console.log("cleartimeout");
        clearTimeout(idleTimeout);
      }
    };

    const onBlurListener = () => {
      if ((window as any).cordova && ons.platform.isIOS()) {
        setFocused(false);

        idleTimeout = setTimeout(() => setIOSIdleForAWhile(true), IDLE_FOR_A_WHILE_MILLISECONDS);
      }
    };

    window.addEventListener("focus", onFocusListener);
    window.addEventListener("blur", onBlurListener);

    return () => {
      window.removeEventListener("focus", onFocusListener);
      window.removeEventListener("blur", onBlurListener);
    };
  });

  return {
    isFocused: isFocused,
    isIOSIdleForAWhile: isIOSIdleForAWhile,
  };
}
